<template>
  <div>
    <div class="user-management-header">
      <div class="user-management-title">
        <div class="user-management-icon"></div>
        <div class="user-management-text">
          {{ $t('contactManagement') }}
        </div>
      </div>
      <div>
        <f7-button fill class="botones-registrar" @click="newContact">
          {{ $t('newContact') }}
        </f7-button>
      </div>
    </div>
    <!-- TODO DENY: :show-column-headers="true" (Confirmar si se muestra o no) -->
    <DxDataGrid
      :data-source="usersInfo"
      :remote-operations="false"
      :allow-column-reordering="false"
      :show-borders="false"
      :show-column-lines="false"
      :row-alternation-enabled="true"
      :show-column-headers="false"
      :show-row-lines="true"
      :allow-column-resizing="true"
      class="custom-grid custom-grid-user-management"
      @exporting="onExporting"
    >
      <!-- <DxExport :enabled="true" /> -->
      <DxColumn
        data-field="name"
        :caption="$t('name')"
        data-type="text"
        alignment="left"
        :min-width="150"
      />
      <DxColumn
        data-field="surname"
        :caption="$t('surname')"
        data-type="text"
        :min-width="220"
      />

      <DxColumn
        v-if="isFullPage"
        data-field="addresses"
        :allow-resizing="true"
        :caption="$t('address')"
        :min-width="180"
        data-type="text"
      />

      <DxColumn
        data-field="email"
        :caption="$t('email')"
        :min-width="260"
        data-type="string"
      />
      <DxColumn
        data-field="phone"
        :caption="$t('phone')"
        :min-width="100"
        data-type="string"
      />
      <DxColumn
        v-if="isFullPage"
        data-field="language"
        :caption="$t('language')"
        :min-width="80"
        data-type="string"
        :calculate-cell-value="translateLang"
      />
      <DxColumn
        :buttons="editButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
        width="75"
      />

      <DxSearchPanel
        :visible="false"
        :width="300"
        :placeholder="$t('search')"
        :highlight-case-sensitive="true"
      />

      <DxPager
        :allowed-page-sizes="pageSizes"
        :show-page-size-selector="false"
        :show-info="false"
        info-text="{2} items"
        :visible="true"
      />
      <DxPaging :page-size="5" />
    </DxDataGrid>

    <NewContactPopup
      v-if="showNewContactPopup"
      :edit-data="editData"
    />
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxSearchPanel,
  // DxExport,
} from 'devextreme-vue/data-grid';

import NewContactPopup from '@/components/Contact/NewContactPopup/index.vue';

import users from '@/json/users.json';
import { mapActions, mapGetters, mapState } from 'vuex';

import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import EventBus from '@/services/event-bus';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import iconTrash from '@/static/icons/ic_trash_new.svg';
import iconEdit from '@/static/icons/ic_edit_new.svg';
import iconCopy from '@/static/icons/ic_copy_new.svg';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxSearchPanel,
    // DxExport,
    NewContactPopup,
  },
  props: {
    isFullPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      users,
      pageSizes: [5, 10, 15],
      editButtons: [
        {
          icon: iconEdit,
          cssClass: 'grid-button-icon ic-edit-new',
          onClick: this.editUser,
        },
        {
          icon: iconTrash,
          cssClass: 'grid-button-icon',
          onClick: this.deleteUserFromCompany,
        },
      ],
      editData: {},
    };
  },
  computed: {
    ...mapGetters('company', ['usersInfo']),
    ...mapGetters('user', ['isAdmin']),
    ...mapState('contact', ['showNewContactPopup']),
  },
  beforeMount() {
    EventBus.$on('ProfilePage', async () => {
      if (!this.isAdmin) {
        this.$f7.preloader.hide();
        const MESSAGE = this.$t(
          'error_user_no_permission_to_show_contacts'
        );
        this.$notifyDX(
          {
            MESSAGE,
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
        return;
      }
      try {
        this.$f7.preloader.show();
        await this.getUsers();
      } catch (e) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(e.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    });
  },
  methods: {
    // onToolbarPreparing(e) {
    //   const toolbarItems = e.toolbarOptions.items;

    //   e.toolbarOptions.elementAttr = {
    //     class: 'custom-toolbar',
    //   };

    //   toolbarItems.forEach((item) => {
    //     if (item.name === 'exportButton') {
    //       item.location = 'after';
    //     }

    //     // if (item.name === 'groupPanel') {
    //     //   item.location = 'after';
    //     // }
    //   });
    // },
    async editUser(userToEdit) {
      this.setUserToEdit(userToEdit.row.data.id);

      const userData = userToEdit.row.data;

      this.setUsersPermissionsToEdit();
      this.setUsersAddressesToEdit();

      this.editData.data = {};

      this.editData.isEditing = true;
      this.editData.data.name = userData.name;
      this.editData.data.surname = userData.surname;
      this.editData.data.lang = userData.language;
      this.editData.data.phone = userData.phone;
      this.editData.data.email = userData.email;
      this.editData.data.addresses = userData.addressesCodes;
      this.editData.data.contactCode = userData.contactCode;
      this.editData.data.companyId = userData.companyId;

      this.setEditData(this.editData);
      this.$f7.views.main.router.navigate('/contacts/new');
    },
    applyFramework7DialogTexts() {
      if (!this.$f7) return;

      this.$f7.params.dialog.buttonCancel = this.$t('cancel');
      this.$f7.params.dialog.buttonOk = this.$t('samplesRegister.ok');
    },
    deleteUserFromCompany(userToDelete) {
      this.applyFramework7DialogTexts();
      this.$f7.dialog.confirm(
        `${this.$t('confirm_delete')} <b>${
          userToDelete.row.data.name
        } ${userToDelete.row.data.surname}</b>?`,
        async () => {
          this.$f7.dialog.preloader(
            `${this.$t('deleting_user')}`,
            'primary'
          );
          try {
            await this.deleteUser(userToDelete.row.data.id);
            this.$f7.dialog.close();
            this.$f7.dialog.alert(`${this.$t('user_deleted')}`);
            this.getUsers();
          } catch (e) {
            this.$notifyDX(
              {
                message: e,
                width: 350,
              },
              'error',
              NOTIFY_TIME_LONG
            );
            this.$f7.dialog.close();
          }
        }
      );
    },
    newContact() {
      this.setEditData({
        isEditing: false,
        data: null,
      });
      this.$f7.views.main.router.navigate('/contacts/new');
    },
    onExporting(e) {
      e.component.beginUpdate();
      e.component.columnOption('ID', 'visible', true);
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(
        `${this.$t('contactManagement')}`
      );

      exportDataGrid({
        component: e.component,
        worksheet,
      })
        .then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(
              new Blob([buffer], {
                type: 'application/octet-stream',
              }),
              `${this.$t('contactManagement')}.xlsx`
            );
          });
        })
        .then(() => {
          e.component.columnOption('ID', 'visible', false);
          e.component.endUpdate();
        });

      e.cancel = true;
    },
    ...mapActions('company', [
      'getUsers',
      'setUserToEdit',
      'setUsersPermissionsToEdit',
      'setUsersAddressesToEdit',
      'deleteUser',
    ]),
    translateLang(row) {
      return this.$t(`${row.language}`);
    },
    ...mapActions('contact', [
      'setShowNewContactPopup',
      'setEditData',
    ]),
  },
};
</script>

<style>
.custom-grid-user-management
  .dx-gridbase-container
  > .dx-datagrid-rowsview {
  background: var(--Secondary-Green-10, #f2f8e2);
}
.custom-grid-user-management .dx-datagrid-rowsview .dx-row {
  background: var(--Basic-White, #fff);
}
.custom-grid-user-management .dx-datagrid-pager {
  border-top: none !important;
  background: var(--Secondary-Green-10, #f2f8e2) !important;
}
.custom-grid-user-management .dx-datagrid-headers {
  background: var(--Secondary-Green-10, #f2f8e2) !important;
}
.user-management-header {
  display: flex;
  align-items: center;
  margin: 5px 10px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 0 0;
}
.user-management-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0px;
}
.user-management-icon {
  background-image: url('@/static/icons/ic_user_management.svg');
  display: flex;
  width: 25px;
  height: 24px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
}
.user-management-text {
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  color: #04509f;
}
/* .custom-grid-user-management .dx-toolbar-after {
  display: grid;
  grid-template-columns: 106px 100px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-user-management .dx-toolbar-after :nth-child(1) {
  grid-row: 1;
  grid-column: 1;
} */
</style>
